<template>
    <div class="filter">
       <h2>{{pointStore.filter.FilterHeading}}</h2>
       <p>{{pointStore.filter.FilterText}}</p>
       <div id="filterContainer">
            <categoryfilter 
                :categories="categories" 
                :isMobile="isMobile" 
                @clicked="toggleSelected" 
                @toggleCategory="toggleCategory">
            </categoryfilter>
            <depthfilter 
                :depths="depths" 
                :isMobile="isMobile" 
                @clicked="toggleSelected" 
                @toggleDepth="toggleDepth">
            </depthfilter>
            <productfilter 
                :products="products" 
                :isMobile="isMobile" 
                @clicked="toggleSelected" 
                @toggleProduct="toggleProduct">
            </productfilter>
        </div>
    </div>
</template>

<script setup>
    import categoryfilter from './category-filter.vue';
    import depthfilter from './depth-filter.vue';
    import productfilter from './product-filter.vue';
    import { usePointStore } from '../store/store';

    const pointStore = usePointStore();
    
    const props = defineProps({
        isMobile: Boolean,
        products: Object,
        categories: Object,
        depths: Object,
        filter: Object
    });
    
    const emit = defineEmits([
        'toggleSelected', 
        'toggleCategory',
        'toggleProduct',
        'toggleDepth'
    ]);
    
    function toggleSelected(object) {
        emit('toggleSelected', object);
    }
    function toggleCategory(category){
        emit('toggleCategory', category);
    }
    function toggleProduct(product){
        emit('toggleProduct', product);
    }
    function toggleDepth(depth){
        emit('toggleDepth', depth);
    }
    
  
</script>